import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import { cloneDeep, set as _set, get as _get } from 'lodash'
import { debounce } from '@/utils'

enum DFormInputType {
  Text = 'text',
  Password = 'password',
  Number = 'number',
  Checkbox = 'checkbox',
  Toggle = 'toggle',
  Select = 'select'
}

export interface DFormSection {
  section: string, label?: string, fields: Array<DFormField>
}
export interface DFormField {
  type: DFormInputType
}
export type DFormTemplate = Array<DFormField | DFormSection>


export default /*@__PURE__*/_defineComponent({
  __name: 'DForm',
  props: {
    modelValue: {},
    template: {},
    title: {},
    edit: { type: Boolean }
  },
  emits: ["update:model-value", "update:edit", "confirm", "cancel"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const initialValue = ref(cloneDeep({...props.modelValue}))
onMounted(() => {
  initialValue.value = cloneDeep({...props.modelValue})
})

const emit = __emit

const formValue = computed({
  get: () => props.modelValue,
  set: val => emit('update:model-value', val)
})

const editing = ref(props.edit)
const isEditing = computed({
  get: () => editing.value,
  set: value => {
    editing.value = value
    emit('update:edit', value)
  }
})

function fieldSetter (field: string, value: any) {
  _set(formValue.value, field, value)
  emit('update:model-value', formValue.value)
}

const setField = debounce(fieldSetter, 200)

function getField (field: string) {
  return _get(formValue.value, field)
}

function reset () {
  formValue.value = cloneDeep({...initialValue.value})
  isEditing.value = false
  emit('cancel', formValue.value)
}

function confirm () {
  isEditing.value = false
  initialValue.value = cloneDeep({...props.modelValue})
  emit('confirm', formValue.value)
}


const __returned__ = { DFormInputType, props, initialValue, emit, formValue, editing, isEditing, fieldSetter, setField, getField, reset, confirm, computed, onMounted, ref, watch, get cloneDeep() { return cloneDeep }, get _set() { return _set }, get _get() { return _get }, get debounce() { return debounce } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})